import { Box, SxProps, Theme, Tooltip } from "@mui/material";
import PrecautionOctagon from "~/components/patient/PrecautionOctagon";
import { PrecautionConfig, useOrgConfig } from "~/providers/OrgConfigProvider";

type Props = {
  precautionIds: number[];
  size?: number;
  sx?: SxProps<Theme>;
};

export default function PrecautionMarker({ precautionIds, size = 20, sx }: Props) {
  const { precautions } = useOrgConfig();
  const resolved = precautionIds
    .map((id) => precautions[id])
    .filter((precaution): precaution is PrecautionConfig => precaution != null);

  if (resolved.length === 0) {
    return null;
  }

  const tooltipTitle = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>
      {resolved.map((precaution) => (
        <Box key={precaution.id} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <PrecautionOctagon color={precaution.color} size={10} />
          <span>{precaution.name}</span>
        </Box>
      ))}
    </Box>
  );

  return (
    <Tooltip
      title={tooltipTitle}
      placement="top"
      arrow
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            boxShadow: 3,
            border: "1px solid",
            borderColor: "divider",
          },
        },
        arrow: {
          sx: {
            color: "background.paper",
            "&::before": {
              border: "1px solid",
              borderColor: "divider",
            },
          },
        },
      }}
    >
      <Box component="span" sx={{ position: "relative", display: "inline-flex", ...sx }}>
        <PrecautionOctagon color="#000000" size={size} />
        <Box
          component="span"
          sx={{
            position: "absolute",
            inset: 0,
            color: "#FFFFFF",
            fontSize: Math.round(size * 0.45),
            fontWeight: 700,
            lineHeight: `${size}px`,
            textAlign: "center",
          }}
        >
          P
        </Box>
      </Box>
    </Tooltip>
  );
}
